import React from 'react';
import { Row } from 'react-table';

import isVacant from './is-vacant';
import sortByName from './sort-by-name';

import { ITableRow } from '../types';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function createNameColumn() {
  return {
    id: 'name',

    accessor: ({ familyName, givenName, nickname }: ITableRow): string => {
      if (nickname) {
        return `${givenName} "${nickname}" ${familyName}`;
      }
      return `${givenName} ${familyName}`;
    },

    Cell: ({
      value: name,
      row: {
        original: { slug },
      },
    }: {
      value: string;
      row: Row<ITableRow>;
    }): JSX.Element => {
      const nameUrl = `/directory/${slug.replace('person-', '')}/`;

      if (isVacant(name)) {
        return <span>{name}</span>;
      }
      return (
        <a href={nameUrl}>
          <strong>{name}</strong>
        </a>
      );
    },

    Header: 'Name',

    sortType: sortByName,
  };
}
